import api from '../client';

export const UsersService = {
  getUsers: () => api.get('/auth/users'),
  getUserById: (id) => api.get(`/auth/users/${id}`),
  updateUser: (id, data) => api.patch(`/auth/users/${id}`, data),
  deleteUser: (id) => api.delete(`/auth/users/${id}`),
  uploadAvatar: (id, data) => api.post(`/auth/users/${id}/avatar`, data),
};
